import http from '../http';
import { version } from '../version';
const prefix = `${version}/massratio`;

/**
 * 질량비 계산 조회
 * @param {string} codeGrade 코드 등급
 * @param {string} condition 조성 계산 조건
 * @returns {Promise} API 응답
 */
export async function getMassRatioCalculation(codeGrade, condition) {
  return http.post(prefix + `/calculate?codeGrade=${codeGrade}&condition=${condition}`);
}

/**
 * 질량비 계산 결과 저장
 * @param {Object} saveRequest 저장 요청 데이터 (codeGrade, saveData)
 * @returns {Promise} API 응답
 */
export async function saveMassRatioCalculation(saveRequest) {
  return http.post(prefix + `/save`, saveRequest);
}

/**
 * 희석용매에 따른 희석비율 옵션 조회
 * @param {string} solvent 희석용매 값 (예: "VC" 또는 "VC:AC")
 * @param {string} additive 첨가제 값 (선택사항)
 * @returns {Promise} API 응답
 */
export async function getRatiosBySolvent(solvent, additive) {
  let url = prefix + `/ratios-by-solvent?solvent=${encodeURIComponent(solvent)}`;
  if (additive && additive.trim() !== '') {
    url += `&additive=${encodeURIComponent(additive)}`;
  }
  return http.post(url);
}
